/* !
 * index.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	const a = 'is-active';
	const v = 'is-visible';

	document.addEventListener('DOMContentLoaded', function() {

		// 検索ボタンのクリックイベント
		const hl_searchby_business_case = document.querySelector('.hl_searchby_business_case');
		const div_searchby_business_case = document.querySelector('.div_searchby_business_case');
		
		if (hl_searchby_business_case && div_searchby_business_case) {
			gsap.set(div_searchby_business_case, { height: '0', opacity: 0, display: 'none' });
			
			let isShowingCase = true;
			hl_searchby_business_case.addEventListener('click', () => {
				if (isShowingCase) {
					gsap.to(div_searchby_business_case, { height: 'auto', opacity: 1, display: 'block' });
				} else {
					gsap.to(div_searchby_business_case, { height: 0, opacity: 0, display: 'none' });
				}
				
				isShowingCase = !isShowingCase;
			});
		}

		// Swiperの初期化
		setTimeout(function() {
			// .case-topics-sliderが存在する場合にのみSwiperを初期化
			if (document.querySelector('.case-topics-slider')) {
				// グローバル空間にある既存のインスタンスを確認して破棄
				if (window.caseSwiper && typeof window.caseSwiper.destroy === 'function') {
					window.caseSwiper.destroy(true, true);
				}
				
				// 新しいSwiperインスタンスを作成
				window.caseSwiper = new Swiper('.case-topics-slider .swiper_slider', {
					autoHeight: true,
					spaceBetween: 24,
					speed: 1000,
					slidesPerView: 1,
					grabCursor: true,
					autoplay: {
						delay: 4000,
						disableOnInteraction: false,
					},
					loopPreventsSliding: false,
					pagination: {
						el: '.case-topics-slider .swiper-pagination-slider',
						type: 'bullets',
						clickable: true,
					},
					navigation: {
						nextEl: '.case-topics-slider .swiper-button-next',
						prevEl: '.case-topics-slider .swiper-button-prev',
					},
					keyboard: {
						enabled: true,
					},
				});
			}
		}, 100);

	});

	// ページ読み込み完了後に実行
	// window.addEventListener('load', function () {
	// 	// チェックボックスのイベント設定
	// 	const checkboxes = document.querySelectorAll('.js-check-submit');
	// 	if (checkboxes.length) {
	// 		checkboxes.forEach(function (checkbox) {
	// 			checkbox.addEventListener('change', function () {
	// 				// 次ページにスクロール指示を渡す
	// 				sessionStorage.setItem('scrollToSearchForm', 'true');
	// 				this.closest('form').submit();
	// 			});
	// 		});
	// 	}

	// 	// ページ遷移後のスクロール処理
	// 	if (sessionStorage.getItem('scrollToSearchForm') === 'true') {
	// 		const form = document.querySelector('.js-case-search-form');
	// 		if (form) {
	// 			form.scrollIntoView({ behavior: 'smooth' });
	// 			sessionStorage.removeItem('scrollToSearchForm');
	// 		} else {
	// 			// DOMがまだ生成されてない場合のために念のため観察
	// 			const observer = new MutationObserver(() => {
	// 				const target = document.querySelector('.js-case-search-form');
	// 				if (target) {
	// 					target.scrollIntoView({ behavior: 'smooth' });
	// 					sessionStorage.removeItem('scrollToSearchForm');
	// 					observer.disconnect();
	// 				}
	// 			});
	// 			observer.observe(document.body, { childList: true, subtree: true });
	// 		}
	// 	}
	// });



})(window.FUNCTIONS);